module.exports = __webpack_public_path__ + "media/images/logo-992-a59e67c22666f3494953b866e5f4ea44.jpg";